'use strict'

/**
 * Default value of init params, 
 * that can be injected while intializing any Abc cms Service component
 * 
 * Do not modify below properties, instead pass as param while intializing
 */
module.exports = {
	/**
	 * @type String
	 */
	baseUrl : '',

	/**
	 * @type Boolean
	 */
	debug: false,

	/**
	 * CMS Rest prefix for CTools gateway
	 * @type String
	 */
	abcGatewayPrefix: 'abc-router/',
	
	/**
	 * CMS Rest prefix for backbone gateway
	 * @type String
	 */
	backboneGatewayPrefix: 'abc-backbone/',

	/**
	 * {String} lang
	 */
	lang: 'en',
	
	/**
	 * Configuration option to disable Token caching in client services.
	 * i.e. define it to false if client service is not a global package on page.
	 * {Boolean} cacheToken
	 */
	cacheToken : true,

	/**
	 * rest endpoint prefix for CMS
	 * i.e. /.rest/ for magnolia
	 * @type String
	 */
	restPrefix: '',

	/**
	 * CSRF Token value for passing it in request headers
	 * @type String
	 */
	csrfToken: null,
	
	/**
	 * Digits upto which precision is expected
	 * @type Number
	 */
	precisionDigits: 5,

	/** 
	 * Enable Retry Logic for failed calls
	 * @type Number
	 */
	retries: 0,

	/** 
	 * Status codes which should be Retried along with `null` status code
	 * @type Array
	 */
	retryStatusCodes: [502, 503],

	/**
	 *  Adding below to avoid any unexpected exceptions
	 */
	_EventBus: {
		subscribe: function(){},
		dispatch: function(){},
		unsubscribe: function(){},
		subscriptions: function(){}, 
	},

	/** 
	 * Adding provision to add Request/Response Interceptors
	 * @type Object
	 * @private
	 * Note: Shouldn't be supplied without validating Interceptor signature
	 */
	_Interceptors: {
		// below MUST have two functions
		request: [],
		// below MUST have two functions
		response: [],
	},

	/**
	 * Events Emitted from Util
	 * @type Object
	 * @private
	 * Note: Shouldn't be altered without validating same across all BU
	 */
	UTIL_EVENTS: {
		XHR_FAILED: 'xhr:failed',
		REQUEST_TIMEOUT: 'request:timed-out'
	},

	/**
	 * Cart/Order and Line Item States `Key`
	 * @type Object
	 * @private
	 * Note: Shouldn't be altered without validating same across all workspaces
	 */
	_STATE: {
		ORDER_OPEN: 'Open',
		ORDER_COMPLETED: 'Completed',
		ORDER_CANCELLED: 'Cancelled_order',
		ORDER_CONFIRMED: 'Confirmed_order',

		ITEM_INITIAL: 'Initial',
		ITEM_CANCELLED: 'Cancelled',
		ITEM_CONFIRMED: 'Confirmed',
		ITEM_PROCESSING: 'Processing',
		ITEM_WAITING_FOR_ARTWORK: 'WaitingForArtwork',
		ITEM_WAITING_FOR_DOC_REVIEW: 'WaitingForDocReview',
		ITEM_DOC_REVIEW_IN_PROGRESS: 'DocReviewInProgress',
		ITEM_DOC_REVIEW_APPROVED: 'DocReviewApproved',
		ITEM_DOC_REVIEW_FAILED: 'DocReviewFailed',
		ITEM_DOC_REVIEW_REJECTED: 'DocReviewRejected',
		ITEM_DOC_REVIEW_IN_PROOFING: 'DocReviewInProofing',
		ITEM_DOC_FEEDBACK_REQUESTED: 'DocFeedbackRequested',
		ITEM_SENT_TO_MCP : 'SentToMCP',
		ITEM_READY_FOR_FULFILLMENT: 'ReadyForFulfillment',
		ITEM_FULFILLMENT_ACCEPTED: 'FulfillmentAccepted',
		ITEM_FULFILLMENT_ERROR: 'FulfillmentError',
		ITEM_FULFILLMENT_REJECTED: 'FulfillmentRejected',
		ITEM_PRINTING_IN_PROGRESS: 'PrintingInProgress',
		ITEM_SHIPPED: 'Shipped',
		ITEM_DOC_REVIEW_CANCELLED: 'DocReviewCancelled'
	},



	/** 
	 * Enable Support for v1 custom fields
	 * @type Boolean
	 */
	supportV1: true,


	/** 
	 * Enable Support for v2 custom fields
	 * @type Boolean
	 */
	supportV2: false,
	/**
	 *  Provision to add extra headers
	 */
	headers: {}
};


// WEBPACK FOOTER //
// ./src/core/constants.js